import React from "react";
import { makeStyles } from '@material-ui/core';

// MOVED OUTSIDE COMPONENT to prevent memory leaks
const useStyles = makeStyles({
  flex: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' },
});

export const Loader = () => {
  const classes = useStyles();

  return (
    <div className={classes.flex}>
      <img src={require('../images/gif/loading.gif')} alt='loading_img'  />
    </div>
  )
}
